/**
 * Created by wumian on 17/12/19.
 */
import {SessionStore,Cookie,Bridge,getPlatform} from '../utils'

export const reSetCookier = function (obj) {
  for (var key in obj) {
    Cookie.set(key, obj[key])
  }
};


export function scrollBottom(el) {
  var offsetHeight = el.offsetHeight, scrollTop = el.scrollTop, scrollHeight = el.scrollHeight;


  if (offsetHeight + scrollTop + 5 >= scrollHeight && scrollTop != 0) {

    return true
  }


}



export function  IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}



export function getUrlParams(name) {
  var reg = new RegExp("(^|&|\\?)"+ name +"=([^&]*)(&|$)");
  var r = window.location.href.match(reg);
  if(r!=null)return r[2]; return null;
}


export function cutString(string,name) {
  var str =  string;
  var index = str.indexOf(name);
  var result = str.substring(index+name.length);
  return result
}


export function domOnLoad (init){
// 如果支持 W3C DOM2, 则使用 W3C 方法
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init, false);

// 如果是 IE 浏览器
  } else if (/MSIE/i.test(navigator.userAgent)) {
    // 创建一个 script 标签, 该标签有 defer 属性, 当 document 加载完毕时才会被载入
    document.write('<script id="__ie_onload" defer src="javascript:void(0)"></script>');
    var script = document.getElementById("__ie_onload");
    // 如果文档确实装载完毕, 调用初始化方法
    script.onreadystatechange = function() {
      if (this.readyState == 'complete') {
        init();
      }
    }

// 如果是 Safari 浏览器
  } else if (/WebKit/i.test(navigator.userAgent)) {
    // 创建定时器, 每 0.01 秒检验一次, 如果文档装载完毕则调用初始化方法
    var _timer = setInterval( function() {
      if (/loaded|complete/.test(document.readyState)) {
        clearInterval(_timer);
        init();
      }
    }, 10);

// 如果以上皆不是, 使用最坏的方法 (本例中, Opera 7 将会跑到这里来)
  } else {
    window.onload = function(e) {
      init();
    }
  }
}

export function winOnLoad (init){
  function downloadJSAtOnload() {
    init()
  }
  if (window.addEventListener) {
    window.addEventListener("load", downloadJSAtOnload, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", downloadJSAtOnload);
  } else {
    window.onload = downloadJSAtOnload
  }
}


export function type (obj) {
  var result = {}.toString.call(obj).split(' ')[1];
  return result.substr(0, result.length - 1).toLowerCase()
}


export function changeNull(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] == 'null'  || type(obj[key]) == 'null') {
        obj[key] = ''
      } else {
        if(type(obj[key]) == 'object'){
          changeNull(obj[key])
        }
      }
    }
  }
}







// WEBPACK FOOTER //
// ./src/utils/utils.js